//@ts-nocheck
import React, { useEffect, useState } from "react";
import { Link, useMatch, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../../app/hooks";
import { toast } from "sonner";
import ReviewOverview from "../candidateReview/ReviewOverview";
import ReviewResume from "../candidateReview/ReviewResume";
import ReviewQuestionSetDetails from "../candidateReview/ReviewQuestionSetDetails";
import ReviewQuestionnaireSection from "../candidateReview/ReviewQuestionnaireSection";
import CandidateReviewSecond from "../candidateReview/CandidateReviewSecond";
import ReviewMessageSection from "../candidateReview/ReviewMessageSection";
import ReviewJobTeamDiscussion from "../candidateReview/ReviewJobTeamDiscussion";
import ReviewNotesSection from "../candidateReview/ReviewNotesSection";
import JobScorecardsSection from "../JobScorecardsSection";
import MeetingSection from "../ApplicationMeeting/MeetingSection";
import JobActivity from "../Activity/JobActivity";
import Journey from "../Journey";
import JobFilesSection from "../JobFilesSection";
import AppReviewSection from "../ApplicationAppReview/AppReviewSection";
import AppReviewDetails from "../ApplicationAppReview/AppReviewDetails";
import CandidateDetails from "../CandidateDetails";
import ResumeLayout from "./ResumeLayout";

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

function ChangeLayoutPanel({
  isOpenHeader,
  setIsOpenHeader,
  selectedFilterHeader,
  optionsWithAllStagesHeader,
  applicationDetails,
  setSelectedFilterHeader,
  setapplicationDetails,
  isConductReview,
  appreviewId1,
  QuestionsId,
  sidebarOpen,
  isLoadingApp,
  setIsLoadingApp,
  styles1,
  getRatingLabel,
  openDetails,
  styles,
  setOpenDetails,
}: any) {
  const { baseId, jobId, applicationId } = useParams<{
    baseId: string;
    jobId: string;
    applicationId: string;
  }>();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [activeStatus, setActiveStatus] = useState<
    "Overview" | "Resume" | "Questionnaire" | "Activity" | "Journey"
  >("Overview");
  const [activeStatus1, setActiveStatus1] = useState<
    | "Message"
    | "Files"
    | "Team Discussion"
    | "Notes"
    | "scorecard"
    | "Meeting"
    | "Review"
  >("Review");
  const [meetingData, setMeetingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isTrue, setIsTrue] = useState(false);

  const handleStatusDraft = () => {
    setIsLoadingApp(true);
    setActiveStatus("Overview");
    setTimeout(() => {
      setIsLoadingApp(false);
    }, 500);
  };

  const handleStatusPending = () => {
    setActiveStatus("Resume");
  };

  const handleStatusCompleted = () => {
    setActiveStatus("Questionnaire");
  };

  const handleMeetingCompleted = () => {
    setActiveStatus1("Meeting");
  };

  const handleActivityCompleted = () => {
    setActiveStatus("Activity");
  };

  const handleJourneyCompleted = () => {
    setActiveStatus("Journey");
  };

  const handleReviewStatus = () => {
    setActiveStatus1("Review");
  };

  const handleStatusMessage = () => {
    setActiveStatus1("Message");
  };

  const handleFilesMessage = () => {
    setActiveStatus1("Files");
  };

  const handleStatusTeamDiscussion = () => {
    setActiveStatus1("Team Discussion");
  };

  const handleStatusNotes = () => {
    setActiveStatus1("Notes");
  };

  const handleScorecard = () => {
    setActiveStatus1("scorecard");
  };

  // app review
  const appReviewMatch = useMatch(
    `/${baseId}/job/${jobId}/app/${applicationId}/appreview/:appreviewId/*`
  );
  const appreviewId = appReviewMatch?.params?.appreviewId;

  const getSkillLevelLabel = (scale: any) => {
    const scaleValue = parseFloat(scale);
    if (scaleValue >= 3.5 && scaleValue <= 4.0) return "Strong Yes";
    if (scaleValue >= 1.5 && scaleValue <= 3.4) return "Yes";
    if (scaleValue >= 0.5 && scaleValue <= 1.4) return "Neutral";
    if (scaleValue >= -1.5 && scaleValue <= 0.4) return "No";
    if (scaleValue >= -2.0 && scaleValue <= -1.6) return "Strong No";

    return null;
  };

  return (
    <>
      <div
        className={`flex h-[calc(100vh-61px)]  w-full
                 bg-white ${
                   !sidebarOpen
                     ? "rounded-tl-lg rounded-bl-lg rounded-tr-none rounded-br-lg"
                     : "rounded-tl-none rounded-bl-none rounded-tr-none rounded-br-none"
                 }`}
      >
        <div className="flex justify-center w-full">
          <div className="w-[50%] border-r border-gray-200 h-full overflow-y-auto">
            <div className="flex items-center justify-center ml-[0px] pt-6 pb-4 px-4">
              <button
                className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px]
               border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tl-md rounded-bl-md ${
                 activeStatus === "Overview"
                   ? "bg-[#6b7280] text-white  border-[#6b7280]"
                   : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"
               }`}
                onClick={handleStatusDraft}
              >
                Overview
              </button>
              <button
                className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] 
                    border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)]  ${
                      activeStatus === "Resume"
                        ? "bg-[#6b7280] text-white border-[#6b7280]"
                        : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"
                    }`}
                onClick={handleStatusPending}
              >
                Resume
              </button>
              <button
                className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] 
                    border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)]  ${
                      activeStatus === "Questionnaire"
                        ? "bg-[#6b7280] text-white border-[#6b7280]"
                        : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"
                    }`}
                onClick={handleStatusCompleted}
              >
                Questionnaire
              </button>
              {/* <button
                className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] 
                    border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)]  ${activeStatus === 'Meeting' ? 'bg-[#6b7280] text-white border-[#6b7280]' : 'bg-[#f9fafa] text-[#0000007a] hover:text-black-100'}`}
                onClick={handleMeetingCompleted}
              >
                Meeting
              </button> */}
              <button
                className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] 
                    border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)]  ${
                      activeStatus === "Activity"
                        ? "bg-[#6b7280] text-white border-[#6b7280]"
                        : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"
                    }`}
                onClick={handleActivityCompleted}
              >
                Activity
              </button>
              <button
                className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] border
               border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tr-md rounded-br-md ${
                 activeStatus === "Journey"
                   ? "bg-[#6b7280] text-white border-[#6b7280]"
                   : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"
               }`}
                onClick={handleJourneyCompleted}
              >
                Journey
              </button>
            </div>
            <div
              className={`w-full m-auto max-w-[640px] pt-6 pb-8
                    ${activeStatus === "Resume" ? "px-[10px]" : "px-[50px]"}`}
            >
              <div className="flex-grow">
                {activeStatus === "Overview" && (
                  <div className="w-full h-full">
                    {isLoadingApp ? (
                      <div className="flex items-center justify-center h-[calc(100vh_-_56px)] w-full bg-white">
                        <div className="simple-spinner-loader">
                          <span></span>
                        </div>
                      </div>
                    ) : (
                      <ReviewOverview
                        applicationDetails={applicationDetails}
                        setapplicationDetails={setapplicationDetails}
                        isConductReview={isConductReview}
                        isTrue={isTrue}
                        setIsTrue={setIsTrue}
                      />
                    )}
                  </div>
                )}
                {activeStatus === "Resume" && (
                  <div className="w-full h-full pt-0 pb-8">
                    <ResumeLayout
                      resumeData={applicationDetails?.application?.app_resume}
                      sidebarOpen={sidebarOpen}
                    />
                  </div>
                )}
                {activeStatus === "Questionnaire" && (
                  <div className="w-full h-full pt-2 pb-8">
                    {QuestionsId ? (
                      <div className="w-full max-w-[640px] m-auto">
                        <Link
                          to={`/${baseId}/job/${jobId}/app/${applicationId}/questionnaire`}
                          className="flex items-center gap-x-1 w-full mb-4 ml-[-4px]"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left w-[0.9rem] h-[0.9rem]"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M15 6l-6 6l6 6" />
                          </svg>
                          <span className="text-black-100 text-[13px]">
                            Back to Questionnaire
                          </span>
                        </Link>
                        <ReviewQuestionSetDetails QuestionsId={QuestionsId} />
                      </div>
                    ) : (
                      <ReviewQuestionnaireSection QuestionsId={QuestionsId} />
                    )}
                  </div>
                )}
                {/* {activeStatus === 'Meeting' && (
                  <div className='w-full h-full'>
                    <MeetingSection applicationDetails={applicationDetails?.application} />
                  </div>
                )} */}
                {activeStatus === "Activity" && (
                  <div className="flex-1 flex flex-col bg-white h-full">
                    <div className=" w-full flex justify-center">
                      <div className="w-full m-auto max-w-[640px] pb-8">
                        <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                          Activity
                        </h2>
                        <div className="bg-[#e0e0e0] w-full h-[1px] mt-6 mb-6"></div>
                        <JobActivity
                          applicationDetails={applicationDetails?.application}
                        />
                      </div>
                    </div>
                  </div>
                )}
                {activeStatus === "Journey" && (
                  <div className="flex-1 flex flex-col bg-white h-full">
                    <div className=" w-full flex justify-center">
                      <div className="w-full m-auto max-w-[640px] pb-8">
                        <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                      App Journey
                        </h2>
                        <div className="bg-[#e0e0e0] w-full h-[1px] mt-6 mb-6"></div>
                        <Journey
                          applicationDetails={applicationDetails?.application}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="w-[50%]">
            <div className="flex items-center justify-center ml-[0px] pt-6 pb-4 px-4">
              <button
                className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px]
               border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tl-md rounded-bl-md ${
                 activeStatus1 === "Review"
                   ? "bg-[#6b7280] text-white  border-[#6b7280]"
                   : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"
               }`}
                onClick={handleReviewStatus}
              >
                Review
              </button>
              <button
                className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] 
                    border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)]  ${
                      activeStatus1 === "Message"
                        ? "bg-[#6b7280] text-white border-[#6b7280]"
                        : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"
                    }`}
                onClick={handleStatusMessage}
              >
                Message
              </button>
              {/* <button
                className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] 
                    border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)]  ${activeStatus1 === 'Files' ? 'bg-[#6b7280] text-white border-[#6b7280]' : 'bg-[#f9fafa] text-[#0000007a] hover:text-black-100'}`}
                onClick={handleFilesMessage}
              >
                Files
              </button> */}

              <button
                className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] 
                  border  border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)]  ${
                    activeStatus1 === "Team Discussion"
                      ? "bg-[#6b7280] text-white border-[#6b7280]"
                      : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"
                  }`}
                onClick={handleStatusTeamDiscussion}
              >
                Team Discussion
              </button>
              <button
                className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] 
                    border border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tr-md rounded-br-md ${
                      activeStatus1 === "Meeting"
                        ? "bg-[#6b7280] text-white border-[#6b7280]"
                        : "bg-[#f9fafa] text-[#0000007a] hover:text-black-100"
                    }`}
                onClick={handleMeetingCompleted}
              >
                Meeting
              </button>

              {/* <button
                className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] 
                    border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)] ${activeStatus1 === 'Notes' ? 'bg-[#6b7280] text-white border-[#6b7280]' : 'bg-[#f9fafa] text-[#0000007a] hover:text-black-100'}`}
                onClick={handleStatusNotes}
              >
                Notes
              </button>
              <button
                className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] border
               border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tr-md rounded-br-md ${activeStatus1 === 'scorecard' ? 'bg-[#6b7280] text-white border-[#6b7280]' : 'bg-[#f9fafa] text-[#0000007a] hover:text-black-100'}`}

                onClick={handleScorecard}
              >
                Scorecard
              </button> */}
            </div>
            <div className="flex-grow">
              <div className="h-[calc(100vh_-_124px)] overflow-auto">
                <div className="w-full m-auto max-w-[640px] pt-8 pb-8 px-[50px]">
                  {activeStatus1 === "Message" && (
                    <div className="flex-1 flex flex-col bg-white h-full">
                      <div className=" w-full flex justify-center">
                        <div className="w-full m-auto max-w-[640px] pb-8">
                          <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                            Message
                          </h2>
                          <div className="bg-[#e0e0e0] w-full h-[1px] mt-6 mb-6"></div>
                          <ReviewMessageSection
                            applicationDetails={applicationDetails?.application}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {activeStatus1 === "Files" && (
                    <div className="flex-1 flex flex-col bg-white h-full">
                      <div className=" w-full flex justify-center">
                        <div className="w-full m-auto max-w-[640px] pb-8">
                          <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                            Files
                          </h2>
                          <div className="bg-[#e0e0e0] w-full h-[1px] mt-6 mb-6"></div>
                          <JobFilesSection
                            applicationDetails={applicationDetails?.application}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {activeStatus1 === "Team Discussion" && (
                    <div className="flex-1 flex flex-col bg-white h-full">
                      <div className=" w-full flex justify-center">
                        <div className="w-full m-auto max-w-[640px] pb-8">
                          <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                            Team Discussion
                          </h2>
                          <div className="bg-[#e0e0e0] w-full h-[1px] mt-6 mb-6"></div>
                          <ReviewJobTeamDiscussion
                            applicationDetails={applicationDetails?.application}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {activeStatus1 === "Notes" && (
                    <div className="flex-1 flex flex-col bg-white h-full">
                      <div className=" w-full flex justify-center">
                        <div className="w-full m-auto max-w-[640px] pb-8">
                          <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5">
                            Notes
                          </h2>
                          <div className="bg-[#e0e0e0] w-full h-[1px] mt-6 mb-6"></div>
                          <ReviewNotesSection
                            applicationDetails={applicationDetails?.application}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {activeStatus1 === "Meeting" && (
                    <div className="w-full h-full">
                      <MeetingSection
                        applicationDetails={applicationDetails?.application}
                      />
                    </div>
                  )}

                  {activeStatus1 === "Review" && !appreviewId && (
                    <div className="w-full h-full">
                      <AppReviewSection
                        applicationDetails={applicationDetails?.application}
                        meetingData={meetingData}
                        loading1={loading}
                      />
                    </div>
                  )}

                  {appreviewId && (
                    <div className="flex-1 flex flex-col bg-white h-full py-[34px] lg:py-[50px] px-0 lg:px-0 overflow-auto">
                      <div className="px-[2px] sm:px-0 lg:px-0 w-full flex justify-center">
                        <div className="w-full max-w-[640px]">
                          <Link
                            to={`/${baseId}/job/${jobId}/app/${applicationId}/appreview`}
                            className="flex items-center gap-x-1 w-full mb-4 ml-[-4px]"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left w-[0.9rem] h-[0.9rem]"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M15 6l-6 6l6 6" />
                            </svg>
                            <span className="text-black-100 text-[13px]">
                              Back to App Review
                            </span>
                          </Link>
                          <AppReviewDetails meetingId={appreviewId} />
                        </div>
                      </div>
                    </div>
                  )}

                  {activeStatus1 === "scorecard" && (
                    <div className="w-full h-full pt-2 pb-8">
                      <JobScorecardsSection />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {openDetails && (
          <div className="max-w-[300px] w-full border-l border-gray-200 pt-0 bg-white rounded-tr-lg rounded-br-lg">
            <div className="p-3">
              <h2 className="text-gray-600 px-3 font-medium text-[0.8125rem] mb-3">
                Candidate Details
              </h2>
              {applicationDetails?.application?.ai_rating && (
                <span
                  className={`inline-flex mx-2 my-0 mb-2 w-fit items-center rounded-md ${styles1.bg} px-2 py-1 text-xs font-normal ${styles1.text} ring-1 ring-inset ${styles1.ring}`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                    data-slot="icon"
                    className={`w-3 h-3 mr-[6px] ${styles1.text} `}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                    />
                  </svg>
                  AI:
                  <span className="ml-[4px]">
                    {getRatingLabel(applicationDetails?.application?.ai_rating)}
                    <span className="ml-[2px]">{`(${applicationDetails?.application?.ai_rating})`}</span>
                  </span>
                </span>
              )}

              {applicationDetails?.application?.user_rating && (
                <span
                  className={`flex mt-0 mb-2 mx-2   w-fit items-center rounded-md ${styles.bg} px-2 py-1 text-xs font-normal ${styles.text} ring-1 ring-inset ${styles.ring}`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className={`icon icon-tabler icons-tabler-outline icon-tabler-users w-3 h-3 mr-[6px] ${styles.text} `}
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                    <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
                  </svg>
                  User:
                  <span className="ml-[4px]">
                    {getSkillLevelLabel(
                      applicationDetails?.application?.user_rating
                    )}
                    <span className="ml-[2px]">{`(${applicationDetails?.application?.user_rating})`}</span>
                  </span>
                </span>
              )}

              <CandidateDetails
                applicationDetails={applicationDetails}
                baseId={baseId}
                jobId={jobId}
                applicationId={applicationId}
                setapplicationDetails={setapplicationDetails}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default ChangeLayoutPanel;
